import styled from 'styled-components';
import SvgDecorLogin from '../../others/svg_dist/DecorLogin';

export const Wrapper = styled.div`
	width: 100%;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	overflow-y: auto;
	height: 100%;
`;

export const Container = styled.div`
	display: flex;
	flex-flow: column nowrap;
	margin: auto;
	position: relative;
	height: 100%;
	overflow: hidden;
`;

export const VideoBg = styled.video`
	width: 100%;
	position: absolute;
	object-fit: cover;
	height: 100%;
`;

export const StyledSvgDecorLogin = styled(SvgDecorLogin)`
	width: fit-content;
	position: absolute;
	right: 100px;
	top: 100px;
	fill: #ccc6;
	height: 50px;
	@media screen and (max-width: 900px) {
		display: none;
	}
`;
